import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {withRouter} from 'react-router-dom';
const styles = theme => ({
  title: {
    fontWeight: '500',
    color: theme.palette.grey[600],
  },
  name: {
    width: 'fit-content',
  },
});

const SessionItemSummaryComponent = ({
  numberOfFiles,
  session,
  }) => (
    <Grid container>
      <Grid item xs={6}>
        <Typography variant="subtitle2" >Created at</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography>{moment(session.createdAt).format('DD-MM-YYYY HH:mm')}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="subtitle2" >Last updated</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography>{moment(session.lastModified).fromNow()}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="subtitle2" >Number of items</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography>{numberOfFiles}</Typography>
      </Grid>
    </Grid>
);

SessionItemSummaryComponent.propTypes = {
  numberOfFiles: PropTypes.number.isRequired,
  session: PropTypes.shape({
    id: PropTypes.string,
    createdAt: PropTypes.number,
    lastModified: PropTypes.number,
    name: PropTypes.string,
    files: PropTypes.shape({
      id: PropTypes.string,
      filename: PropTypes.string,
      lastModified: PropTypes.number,
      savedByUser: PropTypes.bool,
    }),
  }).isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,

  /* eslint-enable */
};

export default withStyles(styles)(withRouter(SessionItemSummaryComponent));
